// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__5_C9R","additionalInfo":"AgreementModal_additionalInfo__3TSNk"};